import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=83d5e92a&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83d5e92a')) {
      api.createRecord('83d5e92a', component.options)
    } else {
      api.reload('83d5e92a', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=83d5e92a&", function () {
      api.rerender('83d5e92a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2zb6z4Q4lHfkU/JS/comp/FavElement.vue"
export default component.exports